import { UnstyledButton, Checkbox, Text, createStyles } from "@mantine/core"
import { useUncontrolled } from "@mantine/hooks"
import React from "react"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  button: {
    display: "flex",
    width: "100%",
    borderRadius: theme.radius.lg,
    padding: theme.spacing.lg,
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0],

    "&:hover": {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1],
    },
  },
}))

// ----------------------------------------------------------------------

interface CheckboxCardProps {
  checked?: boolean
  defaultChecked?: boolean
  title: React.ReactNode
  description: React.ReactNode

  onChange?(checked: boolean): void
}

export function CheckboxCard(
  {
    checked,
    defaultChecked,
    onChange,
    title,
    description,
    className,
    ...others
  }: CheckboxCardProps & Omit<React.ComponentPropsWithoutRef<"button">, keyof CheckboxCardProps>): React.JSX.Element {
  const { classes, cx } = useStyles()

  const [ value, handleChange ] = useUncontrolled<boolean>({
    value: checked,
    defaultValue: defaultChecked,
    finalValue: false,
    onChange,
  })

  return (
    <UnstyledButton {...others} onClick={() => handleChange(!value)} className={cx(classes.button, className)}>
      <Checkbox
        checked={value}
        onChange={() => {
        }}
        tabIndex={-1}
        size="md"
        mr="xl"
        styles={{ input: { cursor: "pointer" } }}
      />

      <div>
        <Text fw={500} mb={7} sx={{ lineHeight: 1 }}>
          {title}
        </Text>
        <Text fz="sm" c="dimmed">
          {description}
        </Text>
      </div>
    </UnstyledButton>
  )
}
